
import React, { useState, useEffect } from "react";
import PageHeader from "../../components/PageHeader";
import WasteTypeCategoryUpdateComponent from "../../components/WasteTypeCategory/WasteTypeCategoryUpdate";
import Loader from "react-loader-spinner";
import { viewWasteTypeCategoryAction } from "../../actions";
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";

function WasteTypeCategoryUpdate({ viewWasteTypeCategoryAction }) {

    const params = useParams();
    const id = params.id;
    const [wasteType, setWasteTypeCategoryData] = useState(null);
   
    useEffect(() => {
        window.scrollTo(0, 0);
    });

    useEffect(() => {
        if (id) {
            viewWasteTypeCategoryAction({ id: id }, (err, response) => {
                if (!err) {
                    setWasteTypeCategoryData(response.data.data);
                }
            });
        }
    }, [id]);

    return (
        <div
            style={{ flex: 1 }}
            onClick={() => {
                document.body.classList.remove("offcanvas-active");
            }}
        >
            <div>
                <div className="container-fluid">
                    {wasteType && <PageHeader
                        HeaderText="Waste Type Update"
                        Breadcrumb={[
                            { name: "Waste Types", navigate: "/waste-type-category" },
                            { name: wasteType.title, navigate: `` },
                        ]}
                    />}
                    <div className="row clearfix justify-content-center">
                        {wasteType ? <WasteTypeCategoryUpdateComponent wasteType={wasteType} />
                            : <div className="text-center" style={{marginTop: "50px"}}>
                                <Loader
                                    type="Bars"
                                    color="#00BFFF"
                                    height={100}
                                    width={100}
                                    timeout={3000} //3 secs
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(null, { viewWasteTypeCategoryAction })(WasteTypeCategoryUpdate)
